<template lang="html">
  <v-tooltip class="tooltip" top>
    <template #activator="{ on }">
      <v-icon v-on="on" :color="color">
        {{ icon }}
      </v-icon>
    </template>
    <span class="info-message">
      {{ message }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: false,
      default: 'I\'m an InfoIcon. Looks like someone forgot to give me text.'
    },
    icon: {
      type: String,
      required: false,
      default: 'mdi-alert-circle'
    },
    color: {
      type: String,
      required: false,
      default: 'warning'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
